import BTC from './BTC';
import ETH from './ETH';
import USDC_ERC20 from './USDC_ERC20';
import USDC_TRC20 from './USDC_TRC20';
import USDT_ERC20 from './USDT_ERC20';
import USDT_TRC20 from './USDT_TRC20';

export default ({token}) => {
    if(token === 'BTC') return <BTC />;
    if(token === 'ETH') return <ETH />;
    if(token === 'USDC_ERC20') return <USDC_ERC20 />;
    if(token === 'USDC_TRC20') return <USDC_TRC20 />;
    if(token === 'USDT_ERC20') return <USDT_ERC20 />;
    if(token === 'USDT_TRC20') return <USDT_TRC20 />;
    return <></>;
}